import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import $ from 'jquery' // para modificar el duallistbox de bootstrap

class PerfilesAsignacion extends Component {
    constructor(props) {
        super(props)
        this.state = {
            perfilesFiltro: ''
        }
        this.updateEmptyMessage = this.updateEmptyMessage.bind(this)
    }

    componentDidMount() {
        // El duallistbox se crea fuera de React; esperamos un poco más para asegurar que esté inicializado
        setTimeout(this.updateEmptyMessage, 200)
    }

    componentDidUpdate(prevProps) {
        const prev = (prevProps && prevProps.formData) ? prevProps.formData.perfiles_asignables : undefined
        const next = (this.props && this.props.formData) ? this.props.formData.perfiles_asignables : undefined

        if (prev !== next || prevProps.action !== this.props.action) {
            // Esperar un poco más para asegurar que el duallistbox esté completamente inicializado
            setTimeout(this.updateEmptyMessage, 150)
        }
    }

    updateEmptyMessage() {
        const { action, formData, intl } = this.props

        // Solo aplica en ADD/EDIT/DUPLICATE, no en VIEW
        if (action === 'VIEW') return

        // Scope: SOLO el duallistbox del select #perfiles_asignables
        const $original = $('#perfiles_asignables')
        if ($original.length === 0) return

        // El plugin inserta el container ANTES del select original (insertBefore)
        const $container = $original.prev('.bootstrap-duallistbox-container')
        if ($container.length === 0) return

        const $box2 = $container.find('.box2')
        const $select2 = $box2.find('select')
        if ($box2.length === 0 || $select2.length === 0) return

        const perfilesAsignables = (formData && formData.perfiles_asignables) ? formData.perfiles_asignables : []
        const isEmpty = perfilesAsignables.length === 0

        let $watermark = $box2.find('.perfiles-asignables-watermark')
        if ($watermark.length === 0) {
            $box2.css('position', 'relative')
            $watermark = $('<div class="perfiles-asignables-watermark"></div>')
            $watermark.css({
                position: 'absolute',
                left: 0,
                right: 0,
                pointerEvents: 'none',
                padding: '0 12px',
                color: '#6c757d',
                fontSize: '14px',
                fontStyle: 'italic',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 2,
                opacity: 0.85,
            })
            $box2.append($watermark)
        }

        if (!isEmpty) {
            $watermark.hide()
            return
        }

        const message = intl.formatMessage({
            id: 'perfilesAsignacion.render.asignacion_todos',
            defaultMessage:
                'Si no selecciona ningún perfil, el usuario que tenga este perfil podrá asignar TODOS los perfiles.',
        })

        // Posicionar el watermark dentro del bloque gris (select del lado derecho)
        const pos = $select2.position()
        $watermark
            .text(message)
            .css({
                top: pos ? pos.top : 0,
                height: $select2.outerHeight(),
            })
            .show()
    }

    render() {
        const { formData, action, perfilesDisponibles, duallistboxRef } = this.props;
        
        // Filtrar el perfil actual de la lista de perfiles disponibles (un perfil no puede elegir si asignarse a sí mismo, se asume que el perfil siempre prodrá asignar su propio perfil)
        const perfilesFiltrados = perfilesDisponibles ? perfilesDisponibles.filter(perfil => perfil.id !== formData.id) : []; // sacamos el perfil actual de la lista de perfiles disponibles
        
        return (
            <div className="form-body">
                <div className="card pull-up">
                    <div className="card-content">
                        <div className="card-body">
                            <h4 className="form-section">
                                <i className="ft-users"></i><FormattedMessage id="perfilesAsignacion.render.header_asignacion" defaultMessage=" Perfiles Asignables"/>
                            </h4>
                            <div className="row">
                                <div className="col-md-12">
                                    {action === 'VIEW' ? (
                                        <div className="form-group">
                                            <label htmlFor="perfilesAsignablesView">
                                                <FormattedMessage id="perfilesAsignacion.render.perfiles_disponibles" defaultMessage="Perfiles Disponibles:" />
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                placeholder={this.props.intl.formatMessage({ id: 'perfilesAbm.render.general_data.filtros', defaultMessage: 'Filtros' })}
                                                onChange={e => {
                                                    this.setState({ perfilesFiltro: e.target.value });
                                                }}
                                            />
                                            <select
                                                size="10"
                                                className="form-control w-100"
                                                id="perfilesAsignablesView"
                                            >
                                                {(formData.perfiles_asignables || [])
                                                    .filter(perfilId => {
                                                        if (!this.state.perfilesFiltro) return true;
                                                        const perfil = perfilesFiltrados.find(p => p.id === perfilId);
                                                        return perfil && perfil.nombre.toLowerCase().includes(this.state.perfilesFiltro.toLowerCase());
                                                    })
                                                    .map(perfilId => {
                                                        const perfil = perfilesFiltrados.find(p => p.id === perfilId);
                                                        return perfil ? (
                                                            <option key={perfil.id} value={perfil.id}>
                                                                {perfil.nombre}
                                                            </option>
                                                        ) : null;
                                                    })
                                                }
                                            </select>
                                        </div>
                                    ) : (
                                        <>
                                        <p className="mb-2">
                                            <FormattedMessage 
                                                id="perfilesAsignacion.render.descripcion" 
                                                defaultMessage="Seleccione los perfiles que este perfil podrá asignar en el ABM de usuarios:" 
                                            />
                                        </p>
                                        <div className="form-group">
                                            <select 
                                                multiple="multiple" 
                                                size="10" 
                                                ref={duallistboxRef}
                                                id="perfiles_asignables" 
                                                name="perfiles_asignables"
                                                value={formData.perfiles_asignables || []}
                                                onChange={this.props.handlePerfilesChange}
                                                style={{ opacity: 0, position: 'absolute', pointerEvents: 'none' }}
                                            >
                                                {perfilesFiltrados.map((perfil) => {
                                                    return <option key={perfil.id} value={perfil.id}>{perfil.nombre}</option>;
                                                })}
                                            </select>
                                        </div>
                                        </>
                                    )}
                                    <p className="mb-2 d-flex align-items-center">
                                        <span className="text-info mr-1">
                                            <i className="fa fa-info-circle"></i>
                                        </span>
                                        <span>
                                            <FormattedMessage 
                                                id="perfilesAsignacion.render.descripcion_actual" 
                                                defaultMessage="El perfil actual no aparecerá en la lista de perfiles, ya que siempre podrá asignar su propio perfil." 
                                            />
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default injectIntl(PerfilesAsignacion);
